export default {
  name: 'IconMacro'
};